module.exports = __webpack_public_path__ + "img/Bahn_Kran_kl.45b2b99a.jpg";